import React from 'react';
import { useTranslation } from 'react-i18next';
import { startCase } from 'lodash';

const CommissionInfo = ({ commissionTriggerPoint }) => {
  const { t } = useTranslation();
  return (
    <div className="longtail-booking-details__commission-info">
      <span>{t('cms:landlord.long_tail.booking_details.label.commission_trigger_point')}</span>
      <span>{startCase(commissionTriggerPoint?.toLowerCase()) || '-'}</span>
    </div>
  );
};

export default CommissionInfo;
